// Copyright 2024 - MinIO, Inc. All rights reserved.

import React, { useState } from "react";
import {
  Box,
  Button,
  FormLayout,
  InputBox,
  PasswordKeyIcon,
  UsersIcon,
} from "mds";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  setPassword,
  setPasswordRepeat,
  setStep,
  setUsername,
} from "./setupSlice";

const SetupStep2 = () => {
  const dispatch = useAppDispatch();

  const username = useAppSelector((state) => state.setup.username);
  const password = useAppSelector((state) => state.setup.password);
  const passwordRepeat = useAppSelector((state) => state.setup.passwordRepeat);

  const [error, setError] = useState<string>("");

  return (
    <Box sx={{ width: "100%" }}>
      <FormLayout withBorders={false} containerPadding={false}>
        <Box className={"inputItem"}>
          Let's create the first <strong>Admin User</strong>
        </Box>
        <InputBox
          id={"username"}
          placeholder="Email"
          value={username}
          onChange={(e) => dispatch(setUsername(e.target.value))}
          startIcon={<UsersIcon />}
          error={error}
          style={{ marginBottom: 2 }}
        />
        <InputBox
          id={"password"}
          placeholder={"Password"}
          type={"password"}
          value={password}
          onChange={(e) => dispatch(setPassword(e.target.value))}
          startIcon={<PasswordKeyIcon />}
        />
        <InputBox
          id={"password"}
          type={"password"}
          placeholder="Repeat Password"
          value={passwordRepeat}
          onChange={(e) => dispatch(setPasswordRepeat(e.target.value))}
          startIcon={<PasswordKeyIcon style={{ fill: "#999" }} />}
          error={
            password !== "" &&
            passwordRepeat !== "" &&
            password !== passwordRepeat
              ? "Password's don't match"
              : ""
          }
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <Button
            id={"register"}
            type={"button"}
            onClick={() => {
              dispatch(setStep(1));
            }}
          >
            Back
          </Button>
          <Button
            id={"register"}
            type={"button"}
            variant={"callAction"}
            onClick={() => {
              if (username === "") {
                setError("Username cannot be empty");
                return;
              }
              if (password !== passwordRepeat) {
                return;
              }
              dispatch(setStep(3));
            }}
          >
            Setup Access Points
          </Button>
        </Box>
      </FormLayout>
    </Box>
  );
};

export default SetupStep2;
